import { Feature } from './feature';

export enum RecurlyAddOn {
  TESTCLOUD_SESSION_CROSSBROWSER_FREE = 'testcloud_session_crossbrowser_free',
  TESTCLOUD_SESSION_CROSSBROWSER = 'testcloud_session_crossbrowser',
  TESTCLOUD_SESSION_WEBDESKTOP = 'testcloud_session_webdesktop',
  TESTCLOUD_SESSION_MOBILEAPP = 'testcloud_session_mobileapp',
  TESTCLOUD_SESSION_LIVETESTING = 'testcloud_session_livetesting',
  TESTCLOUD_SESSION_PRIVATEDEVICE = 'testcloud_session_privatedevice',
}

export const getFeatureByAddOn = (addOn: string | undefined) => {
  switch (addOn) {
    case RecurlyAddOn.TESTCLOUD_SESSION_WEBDESKTOP:
      return Feature.TESTCLOUD_SESSION_WEB_DESKTOP;
    case RecurlyAddOn.TESTCLOUD_SESSION_MOBILEAPP:
      return Feature.TESTCLOUD_SESSION_MOBILE_APP;
    case RecurlyAddOn.TESTCLOUD_SESSION_LIVETESTING:
      return Feature.TESTCLOUD_SESSION_LIVE_TESTING;
    case RecurlyAddOn.TESTCLOUD_SESSION_PRIVATEDEVICE:
      return Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE;
    case RecurlyAddOn.TESTCLOUD_SESSION_CROSSBROWSER:
    default:
      return Feature.TESTCLOUD_SESSION_CROSS_BROWSER;
  }
};

export const trueSelfServeAddOn = [
  RecurlyAddOn.TESTCLOUD_SESSION_CROSSBROWSER,
  RecurlyAddOn.TESTCLOUD_SESSION_MOBILEAPP,
  RecurlyAddOn.TESTCLOUD_SESSION_PRIVATEDEVICE,
];

export const getAddOnCodeByFeature = (feature: Feature): RecurlyAddOn | undefined => {
  switch (feature) {
    case Feature.TESTCLOUD_SESSION_CROSS_BROWSER:
      return RecurlyAddOn.TESTCLOUD_SESSION_CROSSBROWSER;
    case Feature.TESTCLOUD_SESSION_MOBILE_APP:
      return RecurlyAddOn.TESTCLOUD_SESSION_MOBILEAPP;
    case Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE:
      return RecurlyAddOn.TESTCLOUD_SESSION_PRIVATEDEVICE;
    case Feature.TESTCLOUD_SESSION_LIVE_TESTING:
      return RecurlyAddOn.TESTCLOUD_SESSION_LIVETESTING;
    case Feature.TESTCLOUD_SESSION_WEB_DESKTOP:
      return RecurlyAddOn.TESTCLOUD_SESSION_WEBDESKTOP;
    default:
      return undefined;
  }
};
